//
//
//
//
//



export default {
    created () {
        const title = this.$route.query.title;
        //document.title = title;
    },
    
}



// WEBPACK FOOTER //
// ./src/components/filespdf.vue